
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"22","height":"19","x":"1","y":"2.5","stroke":"#000","rx":"1.86"}}),_c('rect',{attrs:{"width":"3","height":"1.38","x":"3","y":"4.71","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"13","height":"1.38","x":"8","y":"4.71","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('path',{attrs:{"stroke":"#000","d":"M1 8h22"}})])])
          )
        }
      }
    